import * as AccordionPrimitive from "@radix-ui/react-accordion"
import * as DialogPrimitive from "@radix-ui/react-dialog"
import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu"
import * as CheckboxPrimitive from "@radix-ui/react-checkbox"
import * as SwitchPrimitive from "@radix-ui/react-switch"
import * as TabsPrimitive from "@radix-ui/react-tabs"


export function Card({ className = "", ...props }) {
  return (
    <div
      className={`rounded-xl border bg-white p-4 shadow ${className}`}
      {...props}
    />
  )
}


export function Input({ className = "", ...props }) {
  return (
    <input
      className={`w-full rounded-md border px-3 py-2 focus:outline-none focus:ring-2 focus:ring-black ${className}`}
      {...props}
    />
  )
}


export function Textarea({ className = "", ...props }) {
  return (
    <textarea
      className={`w-full rounded-md border px-3 py-2 focus:outline-none focus:ring-2 focus:ring-black ${className}`}
      {...props}
    />
  )
}


export function Label({ className = "", ...props }) {
  return (
    <label
      className={`text-sm font-medium ${className}`}
      {...props}
    />
  )
}


export function Badge({ className = "", ...props }) {
  return (
    <span
      className={`inline-flex items-center rounded-full bg-gray-200 px-3 py-1 text-xs ${className}`}
      {...props}
    />
  )
}


export function Alert({ className = "", ...props }) {
  return (
    <div
      className={`rounded-md bg-yellow-100 text-yellow-800 p-4 ${className}`}
      {...props}
    />
  )
}



export function Accordion({ children, ...props }) {
  return (
    <AccordionPrimitive.Root
      type="single"
      collapsible
      className="w-full"
      {...props}
    >
      {children}
    </AccordionPrimitive.Root>
  )
}

export function AccordionItem({ children, ...props }) {
  return (
    <AccordionPrimitive.Item
      className="border-b"
      {...props}
    >
      {children}
    </AccordionPrimitive.Item>
  )
}

export function AccordionTrigger({ children, ...props }) {
  return (
    <AccordionPrimitive.Trigger
      className="w-full py-3 text-left font-medium"
      {...props}
    >
      {children}
    </AccordionPrimitive.Trigger>
  )
}

export function AccordionContent({ children, ...props }) {
  return (
    <AccordionPrimitive.Content
      className="py-2"
      {...props}
    >
      {children}
    </AccordionPrimitive.Content>
  )
}

/* ================= DIALOG ================= */


export function Dialog({ children, ...props }) {
  return (
    <DialogPrimitive.Root {...props}>
      {children}
    </DialogPrimitive.Root>
  )
}

export function DialogTrigger(props) {
  return <DialogPrimitive.Trigger {...props} />
}

export function DialogContent({ children, ...props }) {
  return (
    <DialogPrimitive.Portal>
      <DialogPrimitive.Overlay className="fixed inset-0 bg-black/50" />
      <DialogPrimitive.Content
        className="fixed top-1/2 left-1/2 w-96 -translate-x-1/2 -translate-y-1/2 bg-white p-6 rounded-lg shadow"
        {...props}
      >
        {children}
      </DialogPrimitive.Content>
    </DialogPrimitive.Portal>
  )
}

/* ================= DROPDOWN MENU ================= */


export function DropdownMenu({ children, ...props }) {
  return (
    <DropdownMenuPrimitive.Root {...props}>
      {children}
    </DropdownMenuPrimitive.Root>
  )
}

export function DropdownMenuTrigger(props) {
  return <DropdownMenuPrimitive.Trigger {...props} />
}

export function DropdownMenuContent({ children, ...props }) {
  return (
    <DropdownMenuPrimitive.Content
      className="bg-white border rounded-md shadow p-2"
      {...props}
    >
      {children}
    </DropdownMenuPrimitive.Content>
  )
}

export function DropdownMenuItem({ children, ...props }) {
  return (
    <DropdownMenuPrimitive.Item
      className="px-3 py-2 text-sm hover:bg-gray-100 rounded"
      {...props}
    >
      {children}
    </DropdownMenuPrimitive.Item>
  )
}

/* ================= CHECKBOX ================= */


export function Checkbox(props) {
  return (
    <CheckboxPrimitive.Root className="h-4 w-4 border rounded" {...props}>
      <CheckboxPrimitive.Indicator>
        ✓
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  )
}

/* ================= SWITCH ================= */


export function Switch(props) {
  return (
    <SwitchPrimitive.Root
      className="w-10 h-6 bg-gray-300 rounded-full relative data-[state=checked]:bg-black"
      {...props}
    >
      <SwitchPrimitive.Thumb className="block w-4 h-4 bg-white rounded-full translate-x-1 data-[state=checked]:translate-x-5 transition" />
    </SwitchPrimitive.Root>
  )
}

/* ================= TABS ================= */


export function Tabs(props) {
  return <TabsPrimitive.Root {...props} />
}

export function TabsList(props) {
  return (
    <TabsPrimitive.List className="flex border-b" {...props} />
  )
}

export function TabsTrigger(props) {
  return (
    <TabsPrimitive.Trigger
      className="px-4 py-2 text-sm data-[state=active]:border-b-2 data-[state=active]:border-black"
      {...props}
    />
  )
}

export function TabsContent(props) {
  return (
    <TabsPrimitive.Content className="p-4" {...props} />
  )
}